import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { ShopRoutingLocationRuleDto } from "@babackapp/private-api-client/types";

const formSchema = z.object({
  id: z.string().trim().min(1, { message: "Required" }),
  key: z.string().trim().min(1, { message: "Required" }),
  value: z.string().trim().min(1, { message: "Required" }),
  operator: z.string().trim().min(1, { message: "Required" }),
  positiveResult: z.string().trim().min(1, { message: "Required" }),
});

type EditOneRoutingLocationRuleValues = z.infer<typeof formSchema>;

type EditOneRoutingLocationRuleProps = {
  onSubmit: (values: EditOneRoutingLocationRuleValues) => void;
  defaultValues: ShopRoutingLocationRuleDto;
};

export const useEditRoutingLocationRulesForm = ({
  onSubmit,
  defaultValues,
}: EditOneRoutingLocationRuleProps) => {
  const form = useForm<EditOneRoutingLocationRuleValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      id: defaultValues.id || "",
      key: defaultValues.key,
      value: defaultValues.value,
      operator: defaultValues.operator,
      positiveResult: defaultValues.positiveResult,
    },
  });

  const handleSubmit = form.handleSubmit(
    (data: EditOneRoutingLocationRuleValues) => {
      onSubmit(data);
    },
  );

  return {
    form,
    setValue: form.setValue,
    control: form.control,
    handleSubmit,
    values: form.watch(),
  };
};
